import { useState } from 'react';
import styles from './Avatar.module.css';

interface Props {
  name: string | null;
  photoUrl: string | null;
}

export function Avatar({ name, photoUrl }: Props) {
  const [failed, setFailed] = useState(false);
  const initial = (name ?? '?').charAt(0).toUpperCase();

  // Google profile photos (lh3.googleusercontent.com) 403 when a Referer header
  // is sent, so we must request them with referrerPolicy="no-referrer". Fall
  // back to the initial if the image still fails (deleted/private avatars).
  if (photoUrl && !failed) {
    return (
      <img
        className={styles.avatar}
        src={photoUrl}
        alt=""
        referrerPolicy="no-referrer"
        loading="lazy"
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div className={styles.fallback} aria-hidden>
      {initial}
    </div>
  );
}
